export default [

//    { path: '/history/:id', name: 'history', component: require('./components/page/History.vue').default },
    { path: '/dashboard', component: require('./components/page/Dashboard.vue').default },
    { path: '/profile', component: require('./components/page/Profile.vue').default },
    { path: '/options', component: require('./components/page/options/Options.vue').default },
    { path: '/message', component: require('./components/page/options/MessagePage.vue').default },
    { path: '/users', component: require('./components/page/options/Users.vue').default },
    { path: '/catalogs', component: require('./components/page/product/Catalogs').default },
    { path: '/filials', component: require('./components/page/Filial.vue').default },
    { path: '/products', component: require('./components/page/product/Products.vue').default },

    { path: '/category', component: require('./components/page/product/Category.vue').default },

    // { path: '/category', component: require('./components/page/product/Category.vue').default },

    { path: '/login', component: require('./components/auth/Login.vue').default },
    { path: '/userstat', component: require('./components/page/UserStat.vue').default },

    { path: '/zakaz', component: require('./components/page/zakaz/Zakaz.vue').default },
    { path: '/zakazAll', component: require('./components/page/zakaz/ZakazAll.vue').default },
    { path: '/zakazFuture', component: require('./components/page/zakaz/ZakazFuture.vue').default },
    { path: '/zakazToday', component: require('./components/page/zakaz/ZakazToday.vue').default },
    { path: '/zakazClient', component: require('./components/page/zakaz/ZakazClient.vue').default },
    { path: '/addzakaz', component: require('./components/page/zakaz/AddZakaz.vue').default },
    { path: '/addzakaz/:id', name: 'addzakaz', component: require('./components/page/zakaz/AddZakaz.vue').default },

    { path: '/stat', component: require('./components/page/Stat.vue').default },
    { path: '/home', component: require('./components/page/Home.vue').default },

    { path: '/printToday/:print',name: 'printToday', component: ()  => import('./components/page/printToday.vue'),props: true },
  //site
    { path: '/test2', component: require('./components/page/site/CatalogPage.vue').default },
    { path: '/site', component: require('./components/page/site/site.vue').default },
    {  path: '/userzakaz/:id',name: 'userzakaz', component: ()  => import('./components/page/site/ZakazInfoPage.vue'),props: true},
    {  path: '/catalogid/:id',name: 'catalogid', component: ()  => import('./components/page/site/CatalogPage.vue'),props: true},
    {  path: '/userpay/:id',name: 'userpay', component: ()  => import('./components/page/site/PayPage.vue'),props: true},
    {  path: '/details/:id',name: 'details', component: ()  => import('./components/page/site/DetailsPage.vue'),props: true},
    {  path: '/history/:id',name: 'history', component: ()  => import('./components/page/History.vue'),props: true},
    // { path: '*', component: require('./components/NotFound.vue').default }


];
